import { browserName } from 'react-device-detect';

export const currentBrowserIs = (name: string) => browserName.toLocaleLowerCase().includes(name);
